// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__9A9x2","question":"Question_question__UKGG0","description":"Question_description__3veav"};